import { graphql } from '@/gql';

export const ProductFragment = graphql(`
  fragment CardProduct on Product {
    name
    description
    owner
    lifecycleStatus
    productIdentifier
    projectIdentifier
    version
    updatedAt
  }
`);

export const allProducts = graphql(`
  query allProducts {
    products {
      id
      ...CardProduct
    }
  }
`);

export const createProduct = graphql(`
  mutation createProduct($createProductInput: CreateProductInput!) {
    createProduct(createProductInput: $createProductInput) {
      id
    }
  }
`);

export const updateProduct = graphql(`
  mutation updateProduct($updateProductInput: UpdateProductInput!) {
    updateProduct(updatedProduct: $updateProductInput) {
      id
    }
  }
`);

export const removeProduct = graphql(`
  mutation removeProduct($id: ID!) {
    removeProduct(id: $id) {
      id
    }
  }
`);
